import React from "react";
import ProgressBar from "./ProgressBar";

const Progress = ({ pages, activeIndex, ...rest }) => (
  <ProgressBar {...rest} progress={(100 / (pages.length - 1)) * activeIndex} />
);

export default Progress;
